import { COLOR } from '.';
import { isCFColor } from './is-color';
export const getCFColorValue = (color, fallback = 'transparent') => {
    if (!color) {
        return fallback;
    }
    if (!isCFColor(color)) {
        return color;
    }
    const parts = color.split('-');
    const name = parts.join('_').toUpperCase();
    // Retrieve swatch color from recombined parts
    return (Object.keys(COLOR).includes(name)
        ? COLOR[name]
        : fallback);
};
